import React, { useEffect, useState } from "react";
import LocalHeroIntro from "../LocalHeroIntro";
import IconContent from "../IconContent";
import HeroMedia from "../HeroMedia";
import ListContent from "../ListContent";
import TextContent from "../TextContent";
import queryBrand from "../../Graphql/queryBrand";
import queryBrandAll from "../../Graphql/queryBrandAll";
import api from "../../utils/api";
import { getCategories } from "../../utils/measurements";
import transform from "../../utils/jsonpath-object-transform";
import { mappingSitecoreToLocalHeroIntro, mappingSitecoreToIconContentRight, mappingSitecoreToIconContentLeft, mappingSitecoreToTextContent, mappingOtherGearToTextContent, mappingOtheHeroesToTextContent } from "../../mappings/BrandDetail";
import { MathUtils } from "../../utils";
import { connect } from "react-redux";
import { setDynamicBreadcrumbList } from "../../redux/actions/actions";

const LocalHeroDetail = ({ match, rendering, fields, setDynamicBreadcrumbList }) => {
  const sitecoreBrandItemName = match.params.brand_name;
  const [heroIntroData, setHeroIntroData] = useState({});
  const [itemContentRightData, setItemContentRightData] = useState({});
  const [itemContentLeftData, setItemContentLeftData] = useState({});
  const [textContentData, setTextContentData] = useState({});
  const [getGear, setGetGear] = useState({});
  const [otherHeroes, setOtherHeroes] = useState({});

  const { storePushComponent, getTheGearHeading, otherHeroesHeading, productLink, brandLink } = fields;
  const lang = match.params.lang;
  const scBrandName = match.params.brand_name;

  function getListContentFields(body) {
    return {
      fields: {
        gridType: { fields: { phrase: { value: "normal" } } },
        paddingAboveBottom: { fields: { phrase: { value: "default" } } },
        paddingAboveTop: { fields: { phrase: { value: "default" } } },
        paginationStyle: { fields: { phrase: { value: "carousel" } } },

        headingType: { fields: { phrase: { value: "span" } } },
        headingBody: {
          value: `<span class="type-h1">${body.value}</span>`
        },
        body: { value: null },
        backgroundImage: { value: {} },
        items: []
      }
    };
  }

  async function fetchGemsProductDetail(spuIds) {
    api.product
      .list(null, {
        displayStart: 0,
        displayLength: spuIds.length,
        spuIds: spuIds.map(item => Number(item.spuId))
      })
      .then(res => {
        let _gearFields = getListContentFields(getTheGearHeading);
        let products_measurement = [];
        res.obj.data.forEach((product, index) => {
          let item = mappingOtherGearToTextContent({
            ...product,
            lang
          });
          var spu = spuIds.find(spu => Number(spu.spuId) === product.spuId);
          item.fields.CTA[0].fields.link.value.linkType = "internal";
          item.fields.CTA[0].fields.link.value.href = `${productLink.value.href}/${product.spuId}--${sitecoreBrandItemName}--${spu.name}/`;
          item.fields.CTA[0].fields.link.value.text = productLink.value.text;
          item.fields.subtitleType = { fields: { phrase: { value: "span" } } };
          item.fields.subtitle = {
            value: `<span class="type-body" style="margin-bottom: 10px;">${spu.description}</span>`
          };
          /** Measurements */
          let categories = getCategories(product.categories);
          item.fields.CTA[0].fields.callback = () => {
            let dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: "productClick",
              products: [
                {
                  name: product.productName,
                  id: product.spuId,
                  price: MathUtils.priceFormat(product?.minPrice, lang),
                  brand: sitecoreBrandItemName,
                  category: categories,
                  variant: "",
                  list: 1,
                  position: index
                }
              ]
            });
          };
          item.fields.spuId = product.spuId;
          _gearFields.fields.items.push(item);

          let product_measurement = {
            name: product.productName,
            id: product.spuId,
            price: MathUtils.priceFormat(product?.minPrice, lang),
            brand: sitecoreBrandItemName,
            category: categories,
            variant: ""
          };

          products_measurement.push(product_measurement);
        });

        setGetGear(_gearFields);
        let dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "productImpression",
          products: products_measurement
        });
      });
  }

  //fetch data for for other heroes suggestions
  async function fetchOtherHeroes() {
    const brandQuery = queryBrandAll({
      lang: lang
    });
    api.graphql(null, { query: brandQuery }).then(res => {
      let _gearFields = getListContentFields(otherHeroesHeading);

      var currentBrand = res.data.gear.children.find(obj => obj.name === sitecoreBrandItemName);

      /*** fix breadcrumb */
      let breadCrumbNode = {
        breadcrumbName: currentBrand.fields.find(obj => obj.name === "name")?.value,
        url: "",
        urlLevelText: "",
        childPages: []
      };
      setDynamicBreadcrumbList([breadCrumbNode]);

      var otherLocalHeroesString = currentBrand.fields.find(obj => obj.name === "otheLocalHeroesNames");

      var localHeroesIds = otherLocalHeroesString.value.replace(/{|}|-/g, "").split("|");

      res.data.gear.children.forEach(item => {
        if (localHeroesIds.includes(item.id)) {
          let hero = mappingOtheHeroesToTextContent(item);
          hero.fields.CTA[0].fields.link.value.href = `${brandLink.value.href}/--${item.name}/`;
          hero.fields.CTA[0].fields.link.value.text = brandLink.value.text;
          _gearFields.fields.items.push(hero);
        }
      });
      setOtherHeroes(_gearFields);
    });
  }

  //Fetch brand detail from Sitecore
  async function fetchSitecoreBrandDetail() {
    const brandQuery = queryBrand({
      lang: lang,
      scBrandName: scBrandName
    });
    api.graphql(null, { query: brandQuery }).then(res => {
      let _spuIds = [];

      res.data.brand.children.forEach(child => {
        var result = child.fields.find(obj => obj.name === "spuId");
        var description = child.fields.find(obj => obj.name === "productDescription");
        _spuIds.push({ spuId: result.value, name: child.name, description: description?.value });
      });

      //Fetch products from Gems by spuIds from sitecore
      fetchGemsProductDetail(_spuIds);

      /*** Hero intro  */
      const mappingResultHeroIntro = transform(res, mappingSitecoreToLocalHeroIntro(res));
      const videoSrc = res.data.brand.fields.find(x => x.name === "heroIntroVideo").url;
      mappingResultHeroIntro.fields.video = videoSrc
        ? {
            value: {
              src: videoSrc,
              title: res.data.brand.fields.find(x => x.name === "heroIntroVideo").title,
              mimeType: res.data.brand.fields.find(x => x.name === "heroIntroVideo").mimeType,
              size: res.data.brand.fields.find(x => x.name === "heroIntroVideo").size
            }
          }
        : "";
      mappingResultHeroIntro && setHeroIntroData(mappingResultHeroIntro);

      /*** Icon content  */
      const bodyRight = res.data.brand.fields.find(x => x.name === "iconContentOneBody");
      const headerRight = res.data.brand.fields.find(x => x.name === "iconContentOneHeading");
      const imageRight = res.data.brand.fields.find(x => x.name === "iconContentOneImage")?.src;

      if (bodyRight.value || headerRight.value || imageRight) {
        const mappingResultIconContentRight = transform(res, mappingSitecoreToIconContentRight(res));
        mappingResultIconContentRight && setItemContentRightData(mappingResultIconContentRight);
      }

      const bodyLeft = res.data.brand.fields.find(x => x.name === "iconContentTwoBody");
      const headerLeft = res.data.brand.fields.find(x => x.name === "iconContentTwoHeading");
      const imageLeft = res.data.brand.fields.find(x => x.name === "iconContentTwoImage")?.src;

      if (bodyLeft.value || headerLeft.value || imageLeft) {
        const mappingResultIconContentLeft = transform(res, mappingSitecoreToIconContentLeft(res));
        mappingResultIconContentLeft && setItemContentLeftData(mappingResultIconContentLeft);
      }

      /*** Text content  */
      const bodyText = res.data.brand.fields.find(x => x.name === "textContentBody");

      if (bodyText.value) {
        const mappingResultTextContentData = transform(res, mappingSitecoreToTextContent(res));
        mappingResultTextContentData && setTextContentData(mappingResultTextContentData);
      }
    });
  }

  useEffect(() => {
    fetchSitecoreBrandDetail();
    fetchOtherHeroes();

    return function cleanup() {
      setDynamicBreadcrumbList(null);
    };
  }, []);

  return (
    <section datasourceid={rendering.dataSource}>
      {heroIntroData && heroIntroData.fields && (
        <LocalHeroIntro
          {...{
            rendering,
            ...heroIntroData
          }}
        />
      )}
      {itemContentRightData && itemContentRightData.fields && <IconContent {...itemContentRightData} />}
      {itemContentLeftData && itemContentLeftData.fields && <IconContent {...itemContentLeftData} />}
      {textContentData && textContentData.fields && <TextContent {...textContentData} />}
      {getGear && getGear.fields && getGear.fields.items.length > 0 && (
        <ListContent
          {...{
            fields: getGear.fields,
            rendering
          }}
        />
      )}
      <HeroMedia
        {...{
          fields: storePushComponent.fields,
          rendering
        }}
      />
      {otherHeroes && otherHeroes.fields && (
        <ListContent
          {...{
            fields: otherHeroes.fields,
            rendering
          }}
        />
      )}
    </section>
  );
};

const mapDispatchToProps = dispatch => ({
  setDynamicBreadcrumbList: breadcrumbList => dispatch(setDynamicBreadcrumbList(breadcrumbList)),
  dispatch
});
export default connect(null, mapDispatchToProps)(LocalHeroDetail);
